import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
export function ObjectionsSection() {
  return <section className="py-8 bg-[#FAFAF8]" data-id="element-108">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-110">
          <div className="w-12 h-12 bg-[#0ABFBC]/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-111">
            <HelpCircle className="w-6 h-6 text-[#0ABFBC]" data-id="element-112" />
          </div>

          <h2 className="text-3xl font-bold text-[#1a1a2e] mb-4 font-montserrat" data-id="element-113">
            ¿Y si no funciona en mi caso?
          </h2>

          <div className="space-y-3 text-lg text-gray-700" data-id="element-114">
            <p data-id="element-115">Esta guía no promete cambios mágicos de la noche a la mañana.</p>
            <p className="font-medium text-[#1a1a2e]" data-id="element-116">
              Te ofrece estructura, claridad y pasos concretos.
            </p>
            <p data-id="element-117">
              Si aplicas el método de forma consistente, comenzarás a notar
              mejoras significativas en la dinámica familiar. Está diseñado para
              adaptarse a diferentes edades y situaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}